import React from "react";

type NotificationSettingTriggerIconProps = {
  color?: string;
};

const NotificationSettingTriggerIcon = (
  props: NotificationSettingTriggerIconProps
) => {
  const { color } = props;

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.22801 2.60923C7.76691 1.99301 7.13842 1.52234 6.41742 1.25329C5.69642 0.984236 4.91329 0.928136 4.16131 1.09167C3.40933 1.25521 2.72019 1.63149 2.17599 2.17569C1.63178 2.71989 1.25545 3.40908 1.09181 4.16116C0.928166 4.91325 0.984117 5.69653 1.25299 6.41771C1.52187 7.13889 1.99234 7.76756 2.60837 8.22886M4.50561 5.2095L6.33612 11.3105C6.36425 11.4045 6.41629 11.4896 6.48716 11.5574C6.55803 11.6253 6.6453 11.6736 6.74043 11.6976C6.83556 11.7217 6.93529 11.7206 7.02988 11.6945C7.12447 11.6684 7.21067 11.6182 7.28006 11.5489L8.4009 10.4279L10.8065 12.8339C10.8592 12.8865 10.9217 12.9283 10.9905 12.9568C11.0593 12.9853 11.133 13 11.2075 13C11.2819 13 11.3556 12.9853 11.4244 12.9568C11.4932 12.9283 11.5557 12.8865 11.6084 12.8339L12.8339 11.6081C12.8866 11.5554 12.9283 11.4929 12.9568 11.4241C12.9853 11.3553 13 11.2816 13 11.2071C13 11.1326 12.9853 11.0589 12.9568 10.9901C12.9283 10.9213 12.8866 10.8588 12.8339 10.8061L10.4283 8.40016L11.5503 7.28073C11.6197 7.21138 11.6699 7.12521 11.696 7.03065C11.7221 6.93609 11.7233 6.83637 11.6993 6.74123C11.6754 6.6461 11.6272 6.55881 11.5594 6.4879C11.4916 6.41698 11.4066 6.36487 11.3126 6.33665L5.21186 4.50589C5.11406 4.47686 5.01024 4.47473 4.91133 4.49972C4.81242 4.52472 4.72208 4.57591 4.6498 4.64792C4.57752 4.71993 4.52599 4.81009 4.50061 4.90891C4.47524 5.00774 4.47697 5.11158 4.50561 5.2095Z"
        stroke={color || "#739CFF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationSettingTriggerIcon;
